import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { ButtonsApart } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import {
	CancelButton,
	ContinueButton,
} from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	title: string;
	subtitle: string;
	confirmationButtonText?: string;
	onClose: () => void;
	onSubmit: () => void;
}

const ConfirmationModal = ({
	title,
	subtitle,
	confirmationButtonText,
	onClose,
	onSubmit,
}: Props) => {
	return (
		<Modal
			closeButton={true}
			onClose={onClose}
			reactModalProps={{ style: { content: { width: '39rem' } } }}
		>
			<Content>
				<AssetWrapper>
					<AssetsLoader src="/context/admin/mip-manage/attention.png" />
				</AssetWrapper>
				<SectionHeader size="h4b" title={title} />
				<BodyText colorFaded variant="p-md">
					{subtitle}
				</BodyText>
				<ButtonsApart>
					<UIElementIdentifier
						identifier={
							TEST_ELEMENT_IDS.ADMIN_DASHBOARD_CONFIRMATION_MODAL_CANCEL_BUTTON
						}
					>
						<CancelButton onClick={onClose} />
					</UIElementIdentifier>
					<UIElementIdentifier
						identifier={
							TEST_ELEMENT_IDS.ADMIN_DASHBOARD_CONFIRMATION_MODAL_CONTINUE_BUTTON
						}
					>
						<ContinueButton text={confirmationButtonText} onClick={onSubmit} />
					</UIElementIdentifier>
				</ButtonsApart>
			</Content>
		</Modal>
	);
};

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	${SectionHeader} {
		margin-top: 1em;
		margin-bottom: 0.5em;
	}

	${ButtonsApart} {
		width: 100%;
		margin-top: 2em;
		align-self: flex-end;
	}
`;

const AssetWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.375em;
	flex: 1;
`;

const BodyText = styled(Text)`
	max-width: 25em;
	text-align: center;
`;
const _ConfirmationModalExport = memo(ConfirmationModal);

export { _ConfirmationModalExport as ConfirmationModal };
